window.openCtc = function (url) {
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=600,width=600,height=500");
}
